import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { BottomStripe } from '../../components/Footer/components/BottomStripe/index.js';
import { Container } from '../../components/Footer/components/Container.js';
import { Legal } from '../../components/Footer/components/Legal.js';
import { Links } from '../../components/Footer/components/Links/index.js';
import { SocialLinks } from '../../components/Footer/components/SocialLinks/index.js';
import { FOOTER_QA_ID, qaId } from '../../utils/qaId.js';
export const Full = ({
  links,
  socialLinks,
  path = '',
  showTrustElement = false,
  brandName = 'ab in den urlaub'
}) => {
  const {
    t
  } = useTranslation(['footer']);
  return _jsxs(Container, {
    "data-testid": qaId(FOOTER_QA_ID),
    children: [_jsx(Links, {
      links: links,
      path: path,
      showTrustElement: showTrustElement,
      brandName: brandName
    }), _jsxs(BottomStripe, {
      children: [_jsxs(Legal, {
        "data-testid": qaId(FOOTER_QA_ID, 'title', 'copyright'),
        children: [t('copyright', {
          brandName: brandName,
          year: new Date().getFullYear()
        }), _jsx("br", {}), t('allRightsReserved')]
      }), _jsx(SocialLinks, {
        links: socialLinks
      })]
    })]
  });
};